import {motion} from 'framer-motion';
import LuckyWheel from './lucky-wheel';
import ModuleModals from './module-modals';
import Modals from './modals';

export const Overlay = ({className = "", children}) => {
    return (
        <motion.div
            className={`module-modal-overlay ${className}`}
            initial={{ opacity: 0 }}
            animate={{
                opacity: 1,
                transition: {
                    duration: 0.2,
                    ease: "easeOut"
                }
            }}
            exit={{
                opacity: 0,
                transition: {
                    duration: 0.2,
                    delay: 0.18, // ждём полного исчезновения modal
                    ease: "easeIn"
                }
            }}
        >
            {
                typeof children === 'function'
                ? children()
                : children
            }
        </motion.div>
    )
}

export default {
    LuckyWheel,
    ModuleModals,
    Modals
}